var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmCoinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rima",
    x1: 20,
    y1: 1,
    x2: 20,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6B4A11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#E3BE5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFF0BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#E3BE5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B4A11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "beva",
    x1: 7,
    y1: 7,
    x2: 33,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFF0BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#E3BE5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B4A11"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "corea",
    cx: 14.5,
    cy: 13.5,
    r: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1E7383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#134C58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07272F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "glossa",
    x1: 8,
    y1: 6,
    x2: 28,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFFFFF",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ecorea",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "etexta",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.35
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.642 24.445 Q 38.642 24.995 38.367 25.472 L33.922 33.171 Q 33.647 33.647 33.171 33.922 L25.472 38.367 Q 24.995 38.642 24.445 38.642 L15.555 38.642 Q 15.005 38.642 14.528 38.367 L6.829 33.922 Q 6.353 33.647 6.078 33.171 L1.633 25.472 Q 1.358 24.995 1.358 24.445 L1.358 15.555 Q 1.358 15.005 1.633 14.528 L6.078 6.829 Q 6.353 6.353 6.829 6.078 L14.528 1.633 Q 15.005 1.358 15.555 1.358 L24.445 1.358 Q 24.995 1.358 25.472 1.633 L33.171 6.078 Q 33.647 6.353 33.922 6.829 L38.367 14.528 Q 38.642 15.005 38.642 15.555 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.642 24.445 Q 38.642 24.995 38.367 25.472 L33.922 33.171 Q 33.647 33.647 33.171 33.922 L25.472 38.367 Q 24.995 38.642 24.445 38.642 L15.555 38.642 Q 15.005 38.642 14.528 38.367 L6.829 33.922 Q 6.353 33.647 6.078 33.171 L1.633 25.472 Q 1.358 24.995 1.358 24.445 L1.358 15.555 Q 1.358 15.005 1.633 14.528 L6.078 6.829 Q 6.353 6.353 6.829 6.078 L14.528 1.633 Q 15.005 1.358 15.555 1.358 L24.445 1.358 Q 24.995 1.358 25.472 1.633 L33.171 6.078 Q 33.647 6.353 33.922 6.829 L38.367 14.528 Q 38.642 15.005 38.642 15.555 Z",
    fill: "url(#rima)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.497 24.956 L33.541 33.541 L32.657 32.657 L37.29 24.633 Z",
    fill: "#1B1206",
    fillOpacity: 0.406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.541 33.541 L24.956 38.497 L24.633 37.29 L32.657 32.657 Z",
    fill: "#1B1206",
    fillOpacity: 0.406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.956 38.497 L15.044 38.497 L15.367 37.29 L24.633 37.29 Z",
    fill: "#1B1206",
    fillOpacity: 0.297
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.044 38.497 L6.459 33.541 L7.343 32.657 L15.367 37.29 Z",
    fill: "#1B1206",
    fillOpacity: 0.109
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.459 33.541 L1.503 24.956 L2.71 24.633 L7.343 32.657 Z",
    fill: "#FFFFFF",
    fillOpacity: 0.109
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.503 24.956 L1.503 15.044 L2.71 15.367 L2.71 24.633 Z",
    fill: "#FFFFFF",
    fillOpacity: 0.297
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.503 15.044 L6.459 6.459 L7.343 7.343 L2.71 15.367 Z",
    fill: "#FFFFFF",
    fillOpacity: 0.406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.459 6.459 L15.044 1.503 L15.367 2.71 L7.343 7.343 Z",
    fill: "#FFFFFF",
    fillOpacity: 0.406
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.044 1.503 L24.956 1.503 L24.633 2.71 L15.367 2.71 Z",
    fill: "#FFFFFF",
    fillOpacity: 0.297
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.956 1.503 L33.541 6.459 L32.657 7.343 L24.633 2.71 Z",
    fill: "#FFFFFF",
    fillOpacity: 0.109
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.541 6.459 L38.497 15.044 L37.29 15.367 L32.657 7.343 Z",
    fill: "#1B1206",
    fillOpacity: 0.109
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.497 15.044 L38.497 24.956 L37.29 24.633 L37.29 15.367 Z",
    fill: "#1B1206",
    fillOpacity: 0.297
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.642 24.445 Q 38.642 24.995 38.367 25.472 L33.922 33.171 Q 33.647 33.647 33.171 33.922 L25.472 38.367 Q 24.995 38.642 24.445 38.642 L15.555 38.642 Q 15.005 38.642 14.528 38.367 L6.829 33.922 Q 6.353 33.647 6.078 33.171 L1.633 25.472 Q 1.358 24.995 1.358 24.445 L1.358 15.555 Q 1.358 15.005 1.633 14.528 L6.078 6.829 Q 6.353 6.353 6.829 6.078 L14.528 1.633 Q 15.005 1.358 15.555 1.358 L24.445 1.358 Q 24.995 1.358 25.472 1.633 L33.171 6.078 Q 33.647 6.353 33.922 6.829 L38.367 14.528 Q 38.642 15.005 38.642 15.555 Z",
    fill: "none",
    stroke: "#3A2705",
    strokeOpacity: 0.55,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#ecorea)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.1 20a12.9 12.9 0 1 0 25.8 0a12.9 12.9 0 1 0 -25.8 0Z",
    fill: "url(#corea)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.85 20a13.15 13.15 0 1 0 26.3 0a13.15 13.15 0 1 0 -26.3 0Z",
    fill: "none",
    stroke: "#FFF0BE",
    strokeOpacity: 0.5,
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipa)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.642 24.445 Q 38.642 24.995 38.367 25.472 L33.922 33.171 Q 33.647 33.647 33.171 33.922 L25.472 38.367 Q 24.995 38.642 24.445 38.642 L15.555 38.642 Q 15.005 38.642 14.528 38.367 L6.829 33.922 Q 6.353 33.647 6.078 33.171 L1.633 25.472 Q 1.358 24.995 1.358 24.445 L1.358 15.555 Q 1.358 15.005 1.633 14.528 L6.078 6.829 Q 6.353 6.353 6.829 6.078 L14.528 1.633 Q 15.005 1.358 15.555 1.358 L24.445 1.358 Q 24.995 1.358 25.472 1.633 L33.171 6.078 Q 33.647 6.353 33.922 6.829 L38.367 14.528 Q 38.642 15.005 38.642 15.555 Z",
    fill: "url(#glossa)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#etexta)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.036 23.359V22.912H12.997V17.44C12.997 17.231 12.997 17.136 12.804 17.136C12.722 17.136 12.707 17.136 12.64 17.202C12.069 17.744 11.304 17.744 11.148 17.744H11V18.19H11.148C11.267 18.19 11.675 18.181 12.113 18V22.912H11.082V23.359C11.408 23.33 12.195 23.33 12.559 23.33C12.922 23.33 13.709 23.33 14.036 23.359ZM20.835 21.183V20.737C20.575 20.765 19.929 20.765 19.64 20.765C19.209 20.765 18.519 20.765 18.118 20.737V21.183H19.187V22.143C19.187 22.323 19.187 22.599 18.898 22.817C18.705 22.96 18.467 23.017 18.23 23.017C17.591 23.017 16.953 22.741 16.589 22.152C16.27 21.63 16.174 20.955 16.174 20.09C16.174 19.026 16.322 18.475 16.597 18.01C16.894 17.535 17.465 17.183 18.178 17.183C18.972 17.183 19.677 17.905 19.84 19.112C19.863 19.292 19.87 19.311 20.041 19.311C20.234 19.311 20.241 19.292 20.241 19.045V17.003C20.241 16.822 20.241 16.737 20.108 16.737C20.041 16.737 20.026 16.756 19.967 16.822L19.477 17.383C18.935 16.832 18.4 16.737 18.014 16.737C16.188 16.737 15.038 18.133 15.038 20.1C15.038 21.991 16.114 23.463 18.029 23.463C18.274 23.463 19.039 23.444 19.41 22.855C19.64 23.112 20.085 23.359 20.137 23.359C20.241 23.359 20.241 23.235 20.241 23.093V21.183ZM29 23.359V22.912H28.198V17.288H29V16.841H27.36C27.196 16.841 27.115 16.841 27.033 17.079L25.252 22.105L23.47 17.079C23.388 16.841 23.307 16.841 23.144 16.841H21.496V17.288H22.297V22.637C22.297 22.846 22.29 22.855 22.082 22.884C21.904 22.912 21.889 22.912 21.681 22.912H21.496V23.359C21.778 23.33 22.201 23.33 22.49 23.33C22.802 23.33 23.188 23.33 23.492 23.359V22.912H23.307C23.173 22.912 23.047 22.903 22.913 22.884C22.698 22.855 22.691 22.846 22.691 22.637V17.411H22.698L24.717 23.121C24.784 23.311 24.873 23.359 24.955 23.359C25.103 23.359 25.162 23.216 25.192 23.131L27.263 17.288H27.271V22.912H26.469V23.359C26.736 23.33 27.426 23.33 27.731 23.33C28.035 23.33 28.733 23.33 29 23.359Z",
    fill: "#F5DEA4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmCoinIcon);
export default __webpack_public_path__ + "static/media/GMCoinIcon.693e7924064c6f24a7ec860b80c990fc.svg";
export { ForwardRef as ReactComponent };